import { inject, isDevMode } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AgentService } from '../../../services/agent.service';

/**
 * Non-Agent Guard - Prevents agents from accessing certain routes
 * Redirects agents to /catalog
 *
 * Used on admin-orders to block agent access
 */
export const nonAgentGuard: CanActivateFn = (route, state) => {
  const agentService = inject(AgentService);
  const router = inject(Router);

  return agentService.isAgent().pipe(
    map(isAgent => {
      if (isAgent) {
        if (isDevMode()) {
          console.log('[NonAgentGuard] Agent detected, redirecting to unauthorized');
        }
        router.navigate(['/unauthorized']);
        return false;
      }

      // Not an agent, allow access to admin page
      return true;
    })
  );
};
